import * as types from './mutations-types'

export default {
  [types.setUser] (state, user) {
    state.user = user
    if (user !== '') {
      window.localStorage.setItem('user', JSON.stringify(state.user))
    }
  },
  [types.setSeller] (state, seller) {
    state.seller = seller
    if (seller !== '') {
      window.localStorage.setItem('seller', JSON.stringify(state.seller))
    }
  },
  [types.setIsLogged] (state, isLogged) {
    state.isLogged = isLogged
    window.localStorage.setItem('isLogged', isLogged)
  },
  [types.setAdmUser] (state, admUser) {
    if (admUser !== '') {
      window.localStorage.setItem('admUser', JSON.stringify(admUser))
    }
    state.admUser = admUser
  },
  [types.setSubdomain] (state, subdomain) {
    if (subdomain) {
      window.localStorage.setItem('subdomain', subdomain)
    }
  },
  [types.setCust] (state, customer) {
    window.localStorage.setItem('customer', JSON.stringify(customer))
    state.cust = customer
    if (customer !== '') {
      window.localStorage.setItem('customerEmail', JSON.stringify(customer.email))
      if (customer.cpf !== null) {
        window.localStorage.setItem('customerCPF', JSON.stringify(customer.cpf))
      }
    }
  },
  [types.setUserToken] (state, userToken) {
    if (userToken === '') {
      window.localStorage.removeItem('userToken')
      window.localStorage.removeItem('admUser')
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('seller')
      window.localStorage.removeItem('isLogged')
    } else {
      window.localStorage.setItem('userToken', userToken)
    }
    state.userToken = userToken
  },
  [types.setCustomerToken] (state, customerToken) {
    if (customerToken === '') {
      window.localStorage.removeItem('customerToken')
    } else {
      window.localStorage.setItem('customerToken', customerToken)
    }
    state.customerToken = customerToken
  },
  [types.setCurrentRoute] (state, currentRoute) {
    state.currentRoute = currentRoute
  },
  [types.prevRoute] (state, prevRoute) {
    state.prevRoute = prevRoute
  },
  [types.setWizardDone] (state) {
    state.seller.wizard_done = true
    window.localStorage.setItem('seller', JSON.stringify(state.seller))
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/vuex/mutations.js